// export const API_URL =
//   process.env.NODE_ENV === 'production'
//     ? 'https://www.idea888.com/zyNetworkSystem'
//     : 'http://192.168.0.35/zyNetworkSystem';
export const API_URL = 'https://www.idea888.com/zyNetworkSystem';
export default API_URL;
